<div class="asset-tier3-component">
  <div class="row">
    <div class="col-12">
      <div class="mat-h3 rate-card-section-title">{{title}}</div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <mat-form-field>
        <mat-label>Year 1</mat-label>
        <input [inputMask]="createNoDecimalInputMask" matInput type="text" [formControl]="formControlYear1" required>
        @for (errorKey of errorKeys(formControlYear1); track errorKey) {
          <mat-error>
            @if (formControlYear1.touched && formControlYear1.hasError(errorKey)) {
              {{errorMessage(formControlYear1, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-6 col-md-12">
      <mat-form-field>
        <mat-label>Year 2</mat-label>
        <input [inputMask]="createNoDecimalInputMask" matInput type="text" [formControl]="formControlYear2" required>
        @for (errorKey of errorKeys(formControlYear2); track errorKey) {
          <mat-error>
            @if (formControlYear2.touched && formControlYear2.hasError(errorKey)) {
              {{errorMessage(formControlYear2, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="separator-bottom row">
    <div class="col-12">
      <mat-form-field>
        <mat-label>New</mat-label>
        <input [inputMask]="createTwoDecimalInputMask" [formControl]="formControlNewRate" matInput type="text" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlNewRate); track errorKey) {
          <mat-error>
            @if (formControlNewRate.touched && formControlNewRate.hasError(errorKey)) {
              {{errorMessage(formControlNewRate, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field>
        <mat-label>Used to {{formControlYear1.value}} years</mat-label>
        <input placeholder="Rate, or +N for previous bucket + N" [formControl]="formControlAssetBackedLowYear" matInput type="text" required>
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlAssetBackedLowYear); track errorKey) {
          <mat-error>
            @if (formControlAssetBackedLowYear.touched && formControlAssetBackedLowYear.hasError(errorKey)) {
              {{errorMessage(formControlAssetBackedLowYear, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field>
        <mat-label>{{parseToInt(formControlYear1.value) + 1}} to {{formControlYear2.value}} years</mat-label>
        <input placeholder="Rate, or +N for previous bucket + N" [formControl]="formControlAssetBackedMediumYear" matInput required type="text">
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlAssetBackedMediumYear); track errorKey) {
          <mat-error>
            @if (formControlAssetBackedMediumYear.touched && formControlAssetBackedMediumYear.hasError(errorKey)) {
              {{errorMessage(formControlAssetBackedMediumYear, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field>
        <mat-label>{{parseToInt(formControlYear2.value) + 1}} to {{maxYear}} years</mat-label>
        <input placeholder="Rate, or +N for previous bucket + N" [formControl]="formControlAssetBackedHighYear" matInput required type="text">
        <span class="mdi mdi-percent" matSuffix></span>
        @for (errorKey of errorKeys(formControlAssetBackedHighYear); track errorKey) {
          <mat-error>
            @if (formControlAssetBackedHighYear.touched && formControlAssetBackedHighYear.hasError(errorKey)) {
              {{errorMessage(formControlAssetBackedHighYear, errorKey)}}
            }
          </mat-error>
        }
      </mat-form-field>
    </div>
    <mat-divider [inset]="true"></mat-divider>
  </div>
</div>
